import React, { forwardRef, useMemo } from 'react'
import { useSelector } from 'react-redux';
import DropdownForDynamicInput from '../../../../../components/Dropdown/DropdownForDynamicInput';
import { currencyFormate } from '../../../../../components/Date_Formate_Utilitiy/Index';
import DropdownLayout_1 from "../../../../../components/Dropdown/DropdownLayout_1";
import { formatQuantityLong, parseTallyQuantity, formatQuantityWithUnit, parseUnitString, calculateAltUnits, formatTallyQuantity } from "../../../../../components/Date_Formate_Utilitiy/StockItemUtility";
import { removeCurrencyComma } from "../../../../../components/Date_Formate_Utilitiy/Index";

const ItemWithGodown = forwardRef((props, ref) => {
    const { godown_data = null } = useSelector(state => state.common);
    const modal_state = useSelector(state => state.common.modal_state);
    const { handleChange, handleDynamicBlur, handleDynamicFocus, data_item, handleKeyDownItem, inputRefs, setData, data, handleItemDropdownClick, getDecimalPlaces } = props

    const unit_per = useMemo(() => {
        const unitInfo = parseUnitString(data?.unit_name);
        const options = [];
        let idCounter = 1;

        if (unitInfo) {
            if (unitInfo.type === 'Compound') {
                options.push({ id: idCounter++, name: unitInfo.mainUnit });
                options.push({ id: idCounter++, name: unitInfo.baseUnit });
            } else {
                options.push({ id: idCounter++, name: unitInfo.mainUnit });
            }
        }

        if (data?.alt_unit_name && data?.alt_unit_name !== 'Not Applicable') {
            const altUnitInfo = parseUnitString(data.alt_unit_name);
            if (altUnitInfo && altUnitInfo.type === 'Compound') {
                options.push({ id: idCounter++, name: altUnitInfo.mainUnit });
                options.push({ id: idCounter++, name: altUnitInfo.baseUnit });
            } else {
                options.push({ id: idCounter++, name: data.alt_unit_name });
            }
        }
        return options;
    }, [data?.unit_name, data?.alt_unit_name]);

    return (
        <div className='form'>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    transform: 'translate(-50%, -50%)',
                    width: data?.quantity ? '60%' : '30%',
                    height: '60vh',
                    borderWidth: 1,
                    borderColor: 'black',
                    borderStyle: 'solid',
                    background: '#fff',
                    zIndex: 1000,
                    overflow: 'visible'
                }}>
                {data_item?.map((item, index) => (
                    modal_state?.[`godown_name${index} `] && (
                        <DropdownForDynamicInput
                            key={`godown_name${index} `}
                            title={'Godown List'}
                            state={modal_state[`godown_name${index} `]}
                            data={data}
                            data_item={data_item}
                            index={index}
                            setData={setData}
                            input_value={data_item[index]['godown_name']}
                            input_key={'godown_name'}
                            rawData={godown_data}
                            ref={inputRefs.current[`godown_name${index} `]}
                            inputRefs={inputRefs}
                        />
                    )
                ))}

                {data_item?.map((item, index) => (
                    modal_state?.[`per${index} `] && data?.unit_name !== 'Not Applicable' && (
                        <DropdownLayout_1
                            key={`per${index} `}
                            title='Unit List'
                            state={modal_state[`per${index} `]}
                            data={data}
                            index={index}
                            setData={setData}
                            input_value={data?.data_item[index]['per']}
                            input_key={'per'}
                            input_id={'id_unit'}
                            rawData={unit_per}
                            ref={inputRefs.current[`per${index} `]}
                            inputRefs={inputRefs}
                            handleDropdownClick={(key, value) => handleItemDropdownClick(index, key, value)}
                        />)
                ))}
                <div className='container-fluid p-0 m-0'>
                    <div className='row m-0 p-0'>
                        <div className='col'>
                            <label>Allocations of : </label><b style={{ fontSize: '14px' }}>{data?.name}</b>
                        </div>
                    </div>
                    <div className='row m-0 p-0'>
                        <div className='col-12 m-0 p-0'>
                            <p className='m-0 p-0'><label>For : </label>
                                <b style={{ fontSize: '14px' }}>
                                    {data?.quantity && data?.unit_name && data?.unit_name !== 'Not Applicable'
                                        ? formatQuantityLong(parseTallyQuantity(data?.quantity?.split(' ')[0], parseUnitString(data.unit_name)?.factor || 1, (parseUnitString(data.unit_name)?.factor || 1) > 1), data?.unit_name, getDecimalPlaces(data.unit_name))
                                        : data?.value}
                                </b>
                            </p>
                            <div className='row p-0 ps-1 pe-1 m-0 border_2_1px_bottom border_2_2px_top'>
                                <div className={`col-4 text-start ${data?.modal_type === 'by_qty' ? 'col-4 border' : 'col-8'}`}><label>Godown</label></div>
                                {
                                    data?.modal_type === 'by_qty' ?
                                        <>
                                            <div className='col-3 border text-end'><label>Quantity</label></div>
                                            <div className='col-2 border text-end'><label>Rate</label></div>
                                            <div className='col-1 border text-start'><label>Per</label></div>
                                        </> :
                                        null
                                }
                                <div className={`text-end ${data?.quantity ? 'col-2' : 'col-4'}`}><label>Amount</label></div>
                            </div>
                        </div>
                    </div>
                    <div className='row m-0 p-0' style={{ overflow: 'scroll', height: '42vh' }}>
                        <div className='col-12 m-0 p-0'>
                            <div className='row p-0 m-0'>
                                {data_item?.map((item, index) => (
                                    <div key={index} className='col-12 p-0 m-0' style={{ height: 35 }}>
                                        <div className='row p-0 m-0'>
                                            <div className={`mb-1 ${data?.modal_type == 'by_qty' ? 'col-4' : 'col-8'}`}>
                                                <input
                                                    key={index}
                                                    style={{ width: '100%', fontSize: '14px' }}
                                                    type={'text'}
                                                    value={data?.data_item[index]['godown_name']}
                                                    name={'godown_name'}
                                                    onChange={(e) => handleChange(e, index, 'godown_name', e.target.value)}
                                                    onKeyDown={(e) => handleKeyDownItem(e, index, 'godown_name')}
                                                    onFocus={(e) => handleDynamicFocus(e, index, 'godown_name')}
                                                    onBlur={(e) => handleDynamicBlur(e, index, 'godown_name')}
                                                    ref={(el) => {
                                                        inputRefs.current[`godown_name${index} `] = el;
                                                    }}
                                                />
                                            </div>
                                            {
                                                data?.modal_type === 'by_qty' ?
                                                    <>
                                                        <div className='col-3 text-end'>
                                                            <input
                                                                type={'text'}
                                                                style={{ width: '100%', fontSize: '14px', textAlign: 'end', height: 19 }}
                                                                value={data?.data_item[index]['quantity']}
                                                                name={'quantity'}
                                                                onChange={(e) => handleChange(e, index, 'quantity', e.target.value)}
                                                                onKeyDown={(e) => handleKeyDownItem(e, index, 'quantity')}
                                                                onFocus={(e) => handleDynamicFocus(e, index, 'quantity')}
                                                                onBlur={(e) => handleDynamicBlur(e, index, 'quantity')}
                                                                ref={(el) => {
                                                                    inputRefs.current[`quantity${index} `] = el;
                                                                }}
                                                            />
                                                            <p style={{ fontSize: '14px', height: 15, marginTop: -4 }}><label style={{ fontSize: '14px' }}>({data?.alt_unit_name !== 'Not Applicable' ? data?.data_item[index]['combination_of_units'] : ''})</label></p>
                                                        </div>
                                                        <div className='col-2 ps-0'>
                                                            <input
                                                                type={'text'}
                                                                style={{ width: '100%', fontSize: '14px', height: 19, textAlign: 'end', paddingRight: 5 }}
                                                                value={data?.data_item[index]['rate']}
                                                                name={'rate'}
                                                                onChange={(e) => handleChange(e, index, 'rate', e.target.value)}
                                                                onKeyDown={(e) => handleKeyDownItem(e, index, 'rate')}
                                                                onFocus={(e) => handleDynamicFocus(e, index, 'rate')}
                                                                onBlur={(e) => handleDynamicBlur(e, index, 'rate')}
                                                                ref={(el) => {
                                                                    inputRefs.current[`rate${index} `] = el;
                                                                }}
                                                            />
                                                        </div>
                                                        <div className='col-1 ps-1 position-relative'>
                                                            <input
                                                                type={'text'}
                                                                style={{ width: '100%', fontSize: '14px', height: 19, textAlign: 'start' }}
                                                                value={data?.data_item[index]['per']}
                                                                name={'per'}
                                                                onChange={(e) => handleChange(e, index, 'per', e.target.value)}
                                                                onKeyDown={(e) => handleKeyDownItem(e, index, 'per')}
                                                                onFocus={(e) => handleDynamicFocus(e, index, 'per')}
                                                                onBlur={(e) => handleDynamicBlur(e, index, 'per')}
                                                                ref={(el) => {
                                                                    inputRefs.current[`per${index} `] = el;
                                                                }}
                                                            />
                                                        </div>
                                                    </> :
                                                    null
                                            }
                                            <div className={`${data?.modal_type === 'by_qty' ? 'col-2' : 'col-4'}`}>
                                                <input
                                                    type={'text'}
                                                    className='pe-1'
                                                    style={{ width: '100%', fontSize: '14px', height: 19, textAlign: 'end' }}
                                                    value={data?.data_item[index]['value']}
                                                    name={'value'}
                                                    onChange={(e) => handleChange(e, index, 'value', e.target.value)}
                                                    onKeyDown={(e) => handleKeyDownItem(e, index, 'value')}
                                                    onFocus={(e) => handleDynamicFocus(e, index, 'value')}
                                                    onBlur={(e) => handleDynamicBlur(e, index, 'value')}
                                                    ref={(el) => {
                                                        inputRefs.current[`value${index} `] = el;
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className='row m-0 p-0 border_2_2px_top' style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        height: '42px'
                    }}>
                        <div className='col-4'>
                            <label><b>Total</b></label>
                        </div>
                        <div className='col-3' style={{ fontSize: '14px', textAlign: 'end' }}>
                            {
                                (() => {
                                    if (data?.modal_type !== 'by_qty') return null;

                                    const totalQty = data?.total_quantitiy_allocation;
                                    if (!totalQty) return null;

                                    const unitInfo = parseUnitString(data?.unit_name);
                                    let totalAltQtyFormatted = "";

                                    if (data?.alt_unit_name && data?.alt_unit_name !== 'Not Applicable') {
                                        const altUnitInfo = parseUnitString(data?.alt_unit_name);
                                        const altPrecision = getDecimalPlaces(data?.alt_unit_name);
                                        const totalAltUnits = calculateAltUnits(totalQty, data);
                                        if (altUnitInfo && altUnitInfo.type === 'Compound') {
                                            totalAltQtyFormatted = formatTallyQuantity(totalAltUnits, altUnitInfo.factor, altPrecision, altUnitInfo);
                                        } else {
                                            totalAltQtyFormatted = formatTallyQuantity(totalAltUnits, 1, altPrecision, altUnitInfo);
                                        }
                                    }

                                    return (
                                        <>
                                            <b>{formatQuantityWithUnit(totalQty, unitInfo?.factor || 1, unitInfo?.mainUnit || data?.unit_name, getDecimalPlaces(data?.unit_name), unitInfo)}</b>
                                            {totalAltQtyFormatted && (
                                                <p style={{ fontSize: '14px', height: 15, marginTop: -4, padding: 0, marginBottom: 0 }}>
                                                    <label style={{ fontSize: '14px' }}>({totalAltQtyFormatted})</label>
                                                </p>
                                            )}
                                        </>
                                    );
                                })()
                            }
                        </div>
                        <div className='col-2'></div>
                        <div className='col-1'></div>
                        <div className='col-2 p-0 pe-1' style={{ fontSize: '14px', textAlign: 'end' }}>
                            <b>{data.total_amount_allocation ? currencyFormate(data.total_amount_allocation) : null}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
});

export default ItemWithGodown;
